console.log('js/components/customer/general.js -> v0.1.0');

(() => {
	document.querySelector('body').classList.remove('no-js');
	let globalCurrentModal;

	document.addEventListener('click', function(event) {
		if (event.target.dataset.toggle == "modal") {
			// current modal that is opened
			globalCurrentModal = event.target.getAttribute('href');
		}

		if (event.target.classList.contains('modal-backdrop-light') && globalCurrentModal !== undefined) {
			let form = globalCurrentModal + ' form';
			validation.clearFull(form);
		}

		if (event.target.dataset.dismiss == "modal" && globalCurrentModal !== undefined) {
			let form = globalCurrentModal + ' form';
			validation.clearFull(form);
		}
	});
})();
